// Copyright (C) 2021 Bystronic Laser AG

import { TargetsMetric } from '@/models/enums/TargetsMetric';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { UserTarget } from '@/models/userTarget';
import { userTargetsService } from '@/services/userTargets.service';

function getUserTarget(targetMetric: TargetsMetric): UserTarget | undefined {
  return userTargetsService.store.get(targetMetric);
}

function getSalesTimelineTargets(): number[] | undefined {
  const monthlyPaid = getUserTarget(
    TargetsMetric.SalesFunnelMonthlyPaid,
  )?.target1;
  const r3 = getUserTarget(TargetsMetric.SalesFunnelR3)?.target1;
  const r4 = getUserTarget(TargetsMetric.SalesFunnelR4)?.target1;

  if (monthlyPaid && r3 && r4) {
    return [monthlyPaid, r3, r4];
  } else {
    return undefined;
  }
}

function getDefaultTarget(targetsMetric: TargetsMetric, widget: WidgetEnum) {
  if (widget === WidgetEnum.SalesTimeline) {
    return getSalesTimelineTargets();
  } else {
    const nTargets =
      userTargetsService.store.getMetricNumberOfTargetValues(targetsMetric);
    if (nTargets === 0) {
      return;
    }
    const defaultTarget: number[] = [];
    const userTarget = getUserTarget(targetsMetric);

    if (userTarget) {
      defaultTarget.push(userTarget.target1);
      if (nTargets === 2 && !!userTarget.target2) {
        defaultTarget.push(userTarget.target2);
      }
    }

    return userTarget ? defaultTarget : undefined;
  }
}

export function getTargets(
  selfManagedFilters: boolean,
  target: number[] | undefined,
  targetsMetric: TargetsMetric,
  widget: WidgetEnum,
) {
  return selfManagedFilters ? target : getDefaultTarget(targetsMetric, widget);
}
